import { useEffect, useRef, useState } from "react";
import { useUscSelector } from "../redux/store";

const useStampytThreeSixtySpin = (): { initialized: boolean; reference?: string; token: string } => {
    const reference = useUscSelector((state) => state.vehicle.result?.threeSixtyView?.parameters[0].value);
    const [initialized, setInitialized] = useState(false);

    const oldDefineScript = useRef<typeof window.define>();

    useEffect(() => {
        oldDefineScript.current = window.define;
        window.define = undefined; // Hendrik's require-es script already defines window.define, this breaks stampyt's integrated threejs script loading (OR-7261)

        const stampytScript = document.createElement("script");
        stampytScript.src = "https://component.stampyt.io/v3/webcomponents-lite.js";
        stampytScript.async = true;

        const playerScripts = document.createElement("link");
        playerScripts.rel = "import";
        playerScripts.href = "https://component.stampyt.io/v3/player.html";

        document.head.appendChild(stampytScript);
        document.head.appendChild(playerScripts);
        playerScripts.onload = () => setInitialized(true); // this script is 10x bigger so we can just wait for this one

        return () => {
            document.head.removeChild(stampytScript);
            document.head.removeChild(playerScripts);
            window.define = oldDefineScript.current;
        };
    }, []);

    // hardcoded for now
    return { initialized, reference, token: "orWvNEZU1O68mcfrhvxEC84TOru0vaBJ8js8PDOg" };
};

export default useStampytThreeSixtySpin;
